module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-Honey-eng.9b22429c.png";